// src/pages/ProductDetail.js
import { useParams } from 'react-router-dom';
import './ProductDetails.css';

const productData = {
  1: {
    title: 'Classic Photo Book',
    description: 'This timeless hardcover photo book includes up to 100 pages and is ideal for anniversaries, family albums, and portfolios.',
    images: [
      'https://source.unsplash.com/500x300/?classic,photobook',
      'https://source.unsplash.com/500x300/?family,photos',
      'https://source.unsplash.com/500x300/?book,layout'
    ]
  },
  2: {
    title: 'Wedding Album',
    description: 'Our luxury wedding albums feature elegant layouts, metallic foils, and lay-flat binding for full-spread photos.',
    images: [
      'https://source.unsplash.com/500x300/?wedding,album',
      'https://source.unsplash.com/500x300/?bride,groom',
      'https://source.unsplash.com/500x300/?wedding,ceremony'
    ]
  },
  3: {
    title: 'Baby’s First Year',
    description: 'Capture your baby’s first smiles, steps, and stories in this adorable customizable album with soft pastel themes.',
    images: [
      'https://source.unsplash.com/500x300/?baby,photos',
      'https://source.unsplash.com/500x300/?baby,growth',
      'https://source.unsplash.com/500x300/?baby,album'
    ]
  },
  4: {
    title: 'Travel Memories',
    description: 'A softcover or hardcover option for documenting your journeys with a map feature, text overlays, and location markers.',
    images: [
      'https://source.unsplash.com/500x300/?travel,book',
      'https://source.unsplash.com/500x300/?nature,album',
      'https://source.unsplash.com/500x300/?vacation,photos'
    ]
  }
};

export default function ProductDetail() {
  const { id } = useParams();
  const product = productData[id];

  if (!product) return <div>Product not found.</div>;

  return (
    <div className="product-detail">
      <h1>{product.title}</h1>
      <p>{product.description}</p>

      <div className="detail-gallery">
        {product.images.map((src, index) => (
          <img key={index} src={src} alt={`${product.title} ${index}`} />
        ))}
      </div>

      <a href="/contact" className="primary-btn">Customize Yours</a>
    </div>
  );
}
